import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class LabMeasurementReaderTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.username = null;
		/** @type {string} */
		this.driver_type = null;
		/** @type {string} */
		this.server = null;
		/** @type {string} */
		this.database = null;
		/** @type {string>} */
		this.location = null;
	}

	/**
	 * @typedef {Object} _LabMeasurementReaderTableDtoProps
	 * @property {string} username
	 * @property {string} driver_type	 
	 * @property {string} server
	 * @property {string} database
	 * @property {string} location
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LabMeasurementReaderTableDtoProps} LabMeasurementReaderTableDtoProps
	 */
	/**
	 *
	 * @param {LabMeasurementReaderTableDtoProps} props
	 * @returns {LabMeasurementReaderTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.username = props.username;
		this.driver_type = props.driver_type;
		this.server = props.server;
		this.database = props.database;
		this.location = props.location;
		return this;
	}
}
